var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_1820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 39.9989C31.0449 39.9989 39.9989 31.0449 39.9989 19.9995C39.9989 8.95407 31.0449 0 19.9995 0C8.95407 0 0 8.95407 0 19.9995C0 31.0449 8.95407 39.9989 19.9995 39.9989Z",
    fill: "#EF4B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3408 21.4727C15.1018 21.4727 16.5293 20.0451 16.5293 18.2842C16.5293 16.5232 15.1018 15.0957 13.3408 15.0957C11.5799 15.0957 10.1523 16.5232 10.1523 18.2842C10.1523 20.0451 11.5799 21.4727 13.3408 21.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6592 21.4727C28.4201 21.4727 29.8477 20.0451 29.8477 18.2842C29.8477 16.5232 28.4201 15.0957 26.6592 15.0957C24.8982 15.0957 23.4707 16.5232 23.4707 18.2842C23.4707 20.0451 24.8982 21.4727 26.6592 21.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.485 30.4656C25.1863 30.4656 24.8929 30.3168 24.7219 30.0455C24.6533 29.9389 23.0849 27.5399 19.9988 27.5399C16.9127 27.5399 15.2842 30.0318 15.2684 30.0571C14.9961 30.474 14.4377 30.5912 14.0219 30.3189C13.605 30.0466 13.4879 29.4882 13.7602 29.0724C13.8488 28.9363 15.9829 25.7383 19.9999 25.7383C24.0169 25.7383 26.1637 28.95 26.2491 29.0872C26.513 29.5094 26.3842 30.0645 25.9631 30.3284C25.8143 30.4213 25.6497 30.4656 25.4861 30.4656H25.485Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_1820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.e3cdc54dda32339b619502daea9aad64.svg";
export { ForwardRef as ReactComponent };